<template>
  <VNavigationDrawer
    v-model="drawerStatus"
    class="grey lighten-4"
    fixed
    right
    app
    :permanent="drawerStatus"
    :width="width"
  >
    <VLayout
      fill-height
      column
      align-center
      ma-0
      pa-0
    >
      <VToolbar
        height="64"
        color="primary"
        dark
      >
        <VBtn
          icon
          @click.prevent="onClosed"
        >
          <VIcon>
            close
          </VIcon>
        </VBtn>
        <VToolbarTitle>
          <span>{{ getDrawerTitle }}</span>
        </VToolbarTitle>
      </VToolbar>
      <VLayout
        fill-height
        column
        :justify-center="messageLoading"
        justify-end
        align-center
        ma-0
        pa-0
      >
        <VProgressCircular
          v-if="messageLoading"
          :size="25"
          color="primary"
          indeterminate
        />
        <MessageTable
          v-if="showTable"
          :style="{ width: width + 'px' }"
          @imgClicked="onImgClicked"
        />
        <TextBox
          v-if="!messageLoading"
          show-file
          :sending="messageSending"
          :uploading-file="uploadingFile"
          :style="{ width: width + 'px' }"
        />
      </VLayout>
    </VLayout>
    <VDialog
      v-model="dialog"
      width="600px"
    >
      <VCard
        color="black"
        class="white--text"
      >
        <VCardTitle primary-title>
          <div>
            {{ imgTitle }}
          </div>
        </VCardTitle>
        <VImg
          :src="imgUrl"
          :lazy-src="require('@/assets/import-placeholder.png')"
          max-width="600px"
          aspect-ratio="1.0"
          contain
        >
          <VLayout
            slot="placeholder"
            fill-height
            align-center
            justify-center
            ma-0
          >
            <VProgressCircular
              indeterminate
              color="grey lighten-5"
            />
          </VLayout>
        </VImg>
        <VCardActions>
          <VSpacer />
          <VBtn
            color="white"
            flat="flat"
            @click="dialog = false"
          >
            <VIcon>
              close
            </VIcon>
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </VNavigationDrawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageTable from './MessageTable'
import TextBox from './TextBox'
import _ from 'lodash'

export default {
  name: 'MessageDrawer',
  components: { TextBox, MessageTable },
  data: function () {
    return {
      dialog: false,
      imgUrl: '',
      imgTitle: '',
      width: 400,
      isPermanent: true,
      nextOutPageNumber: 0,
      nextOutPageToken: '',
      nextInPageNumber: 0,
      nextInPageToken: ''
    }
  },
  computed: {
    ...mapGetters({
      isDrawerVisible: 'messageDrawer/getVisibility',
      getDrawerTitle: 'messageDrawer/getTitle',
      allMessages: 'message/getAllMessages',
      messageLoading: 'message/getLoadingStatus',
      messageSending: 'message/getSendingStatus',
      uploadingFile: 'message/getUploadingFile',
      loginAuthToken: 'authentication/getLoginAuthToken',
      user: 'account/getUser'
    }),
    showTable () {
      return this.allMessages.length > 0
    },
    drawerStatus: {
      get: function () {
        return this.isDrawerVisible
      },
      set: function (val) {
        this.setDrawerVisibility({ val })
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (!this.$socket.connected) {
      this.$socket.io.opts.query = {
        authToken: this.loginAuthToken,
        accountSid: _.get(this.user, 'twilio_sid', '')
      }
      this.$socket.connect()
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  sockets: {
    connect: function () {
      // console.log('connected', this.$socket)
    },
    disconnect: function (reason) { },
    error: function (err) { console.error('socket io error', err) },
    reconnect_attempt: function () {
      this.$socket.io.opts.query = Object.assign(this.$socket.io.opts.query,
        { authToken: this.loginAuthToken,
          accountSid: _.get(this.user, 'twilio_sid', '')
        })
    },
    reconnect_failed: function () {},
    newMessageEmit: function (data) {
      // console.log('new message emit')
      // console.log(this.$store._actions)
    },
    updateMessagesEmit: function (data) {
      // console.log('update messages emitted', data)
    }
  },
  methods: {
    ...mapActions({
      setDrawerVisibility: 'messageDrawer/setVisibility'
    }),
    handleResize () {
      // handle resize
      if (window.innerWidth <= 640) {
        this.width = window.innerWidth
      } else {
        this.width = window.innerWidth * 0.3 < 400.0 ? 400 : window.innerWidth * 0.3
      }
    },
    onImgClicked ({ imgUrl, imgTitle }) {
      this.imgUrl = imgUrl
      this.imgTitle = imgTitle
      this.dialog = true
    },
    onClosed () {
      this.setDrawerVisibility({ val: false })
      // this.$socket.emit('close', { accountSid: _.get(this.user, 'twilio_sid', '') })
    }
  }
}
</script>

<style scoped>

</style>
